import { useAtomValue } from "jotai";
import React from "react";
import { showcaseAtom } from "./atoms";
import DesignSlideshow from "../qmade/creator/DesignSlideshow";
import QurealSlideshowViewer from "../showwrapper/QurealSlideshowViewer";

function DisplayShowcase() {
    const showcase = useAtomValue(showcaseAtom);

    return (
        <QurealSlideshowViewer
            ids={[
                "singlepage_BfMDd_copy_y-h9w",
                "singlepage_BfMDd",
                "singlepage_BfMDd_copy_zunqD",
            ]}
        />
    );
    // return <div style={{
    //     width: "100%",
    //     height: "100vh",
    //     display: "flex",
    //     flexDirection: "column",
    //     justifyContent: "center",
    //     alignItems: "center"
    // }}>
    //     {/* <pre>{JSON.stringify(showcase, null, 2)}</pre> */}
    //     <DesignSlideshow
    //         showcase={showcase}
    //         list={[
    //             "singlepage_BfMDd_copy_y-h9w",
    //             "singlepage_BfMDd",
    //             "singlepage_BfMDd_copy_zunqD"
    //         ]} />
    // </div>
}

export default DisplayShowcase;
